import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const plateLookup = (plaque) =>
  api.post("/plate/lookup", { plaque }).then((r) => r.data);

export const fetchDemoPlates = () =>
  api.get("/plate/demo-list").then((r) => r.data);

export const fetchCategories = (type, sousTypePl) => {
  const params = new URLSearchParams();
  if (type) params.set("type_vehicule", type);
  if (sousTypePl) params.set("sous_type_pl", sousTypePl);
  const qs = params.toString();
  return api.get(`/categories${qs ? "?" + qs : ""}`).then((r) => r.data);
};

export const fetchPlSousTypes = () =>
  api.get("/pl/sous-types").then((r) => r.data);

export const fetchPartsCatalog = (q = "") =>
  api
    .get("/parts/catalog" + (q ? `?q=${encodeURIComponent(q)}` : ""))
    .then((r) => r.data);

export const fetchSuppliers = (type = "auto") =>
  api.get(`/suppliers?type_vehicule=${type}`).then((r) => r.data);

export const searchParts = ({ vehicle, part_query, category_id }) =>
  api
    .post("/parts/search", { vehicle, part_query, category_id })
    .then((r) => r.data);

export const getAiAdvice = ({ vehicle, part_query, category_id }) =>
  api
    .post("/ai/advice", { vehicle, part_query, category_id })
    .then((r) => r.data);

export const trackClick = (payload) =>
  api.post("/track/click", payload).then((r) => r.data).catch(() => null);

export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

// Blog public
export const fetchBlogArticles = ({ category, search, limit = 20, skip = 0 } = {}) => {
  const params = new URLSearchParams();
  if (category) params.set("category", category);
  if (search) params.set("search", search);
  params.set("limit", String(limit));
  params.set("skip", String(skip));
  return api.get(`/blog/articles?${params.toString()}`).then((r) => r.data);
};
export const fetchBlogArticle = (slug) =>
  api.get(`/blog/articles/${slug}`).then((r) => r.data);
export const fetchBlogCategories = () =>
  api.get(`/blog/categories`).then((r) => r.data);
export const submitBlogArticle = (payload) =>
  api.post(`/blog/submit`, payload).then((r) => r.data);
